/* 布局 */
//前台
import Layout from "@views/layout";

const specialRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "special",
            name: "SPECIAL",
            meta: {
                title: "专题管理",
                sort: 1,
            },
            component: () => import("@views/business/special/index.vue"),
            redirect: {
                name: "SPECIAL_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "SPECIAL_LIST",
                    meta: {
                        title: "专题管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/special/list.vue"),
                },
                                {
                    path: "add",
                    name: "SPECIAL_ADD",
                    meta: {
                        title: "新增专题表",
                        parentPath: '/business/special/list',
                        operate: true,
                    },
                    component: () => import("@views/business/special/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "SPECIAL_EDIT",
                    meta: {
                        title: "编辑专题表",
                        parentPath: '/business/special/list',
                        operate: true,
                    },
                    component: () => import("@views/business/special/form.vue"),
                },
                                        ],
    },


        ],
};

export default specialRouter;
